module.exports = __webpack_public_path__ + "img/acorn.c3dff908.svg";